import { UpdateCacheAction } from "@/components/cached-messages/types";

export const getPastTenseAction = (action: UpdateCacheAction): string => {
  switch (action) {
    case UpdateCacheAction.CACHE:
      return "cached";
    case UpdateCacheAction.UNCACHE:
      return "uncached";
    case UpdateCacheAction.CLEAR:
      return "cleared";
  }
};
